/**
 * @generated SignedSource<<eb6b20ea994028fc3ef2886922401f81>>
 * @relayHash 2721a257933adfcac8e59da80f97d91c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 51296fc8172d4d462bf194dbcca65432469239bc80f9416593d30fc2909a54a1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IssueTransitionModalQuery } from './IssueTransitionModalQuery.graphql';

import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';

const node: PreloadableConcreteRequest<IssueTransitionModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "51296fc8172d4d462bf194dbcca65432469239bc80f9416593d30fc2909a54a1",
    "metadata": {},
    "name": "IssueTransitionModalQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider
    }
  }
};

export default node;
